import { render, staticRenderFns } from "./read.vue?vue&type=template&id=78ed8a5f&scoped=true"
import script from "./read.vue?vue&type=script&lang=js"
export * from "./read.vue?vue&type=script&lang=js"
import style0 from "./read.vue?vue&type=style&index=0&id=78ed8a5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_vue-template-compiler@2.7.16_webpack@5.96.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ed8a5f",
  null
  
)

export default component.exports